import PropTypes from 'prop-types'
import { memo } from 'react'
import ListItemComponent from '../../../stories/molecules/list-items'
import { iconSizeOptions } from '../../../stories/atoms/icons/icons-sizes'
import StatusIndicationComponent from '../../../stories/atoms/status-indication'
import { statusIndicationMemberVariantOptions } from '../../../stories/atoms/status-indication/constants'
import { getContactIdentityFields } from '../../../../utils/get-contact-identity-fields'
import { isEmpty } from 'lodash'

const ContactItem = ({
  item,
  isSelected = false,
  onToggleSelect = () => {}
}) => {
  const { primary, secondary } = getContactIdentityFields(item)

  if (isEmpty(item)) return null

  return (
    <ListItemComponent.Item
      itemKey={item.id}
      isCheck={isSelected}
      leadingIcon={
        <StatusIndicationComponent
          size={iconSizeOptions['ICON-L']}
          variant={statusIndicationMemberVariantOptions.CONTACT}
        />
      }
      title={primary}
      secondaryText={secondary}
      style={{ borderRadius: 0, border: 0 }}
      onCheck={() => onToggleSelect(item.id)}
      noPadding
    />
  )
}

ContactItem.propTypes = {
  item: PropTypes.object,
  isSelected: PropTypes.bool,
  onToggleSelect: PropTypes.func
}

const MemoizedContactItem = memo(ContactItem)
MemoizedContactItem.displayName = 'ContactItem'

export default MemoizedContactItem
